// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-name-description-input .mat-mdc-form-field {
  width: 100%;
}
.fi-name-description-input .mat-mdc-form-field.mat-form-field-disabled {
  opacity: 0.68;
}
.fi-name-description-input .mat-mdc-form-field.absolute-subscript {
  margin-bottom: 4px;
}
.fi-name-description-input .fi-simple-contenteditable {
  padding: 0 0 20px;
  margin-top: 20px;
}
.fi-name-description-input .fi-info-icon {
  height: calc(100% - 22px) !important;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/name-description-input/name-description-input.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AACQ;EACI,aAAA;AACZ;AACQ;EACI,kBAAA;AACZ;AAEI;EACI,iBAAA;EACA,gBAAA;AAAR;AAEI;EACI,oCAAA;AAAR","sourcesContent":[".fi-name-description-input {\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n        &.mat-form-field-disabled {\r\n            opacity: 0.68;\r\n        }\r\n        &.absolute-subscript {\r\n            margin-bottom: 4px;\r\n        }\r\n    }\r\n    .fi-simple-contenteditable {\r\n        padding: 0 0 20px;\r\n        margin-top: 20px;\r\n    }\r\n    .fi-info-icon {\r\n        height: calc(100% - 22px) !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
